export const shareTranslations = {
  SHARE_TITLE: "De gedeelde tickets zijn beschikbaar in de Tranzer app",
  SHARE_SUBTITLE: "Je wordt nu doorgestuurd"
};
